exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.portlet.portlet-modal[data-v-7448e8b4] {\n    padding: 10px 15px !important;\n}\n.portlet.light .portlet-form .form-actions.fixed-bottom[data-v-7448e8b4],\n.portlet.light .form .form-actions.fixed-bottom[data-v-7448e8b4] {\n    position: absolute;\n    bottom: 0px;\n    right: 20px;\n    left: 20px;\n    background-color: white;\n}\n", ""]);

// exports
